import { ExpenseAccrualPaymentStatusEnum } from "./payment-status-enum";

export const expenseAccrualPaymentStatusLabels = {
  [ExpenseAccrualPaymentStatusEnum.UNPAID]: "Belum Dibayar",
  [ExpenseAccrualPaymentStatusEnum.PARTIALLY_PAID]: "Dibayar Sebagian",
  [ExpenseAccrualPaymentStatusEnum.FULLY_PAID]: "Lunas",
};
